import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from './classes/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _user: User;
  private _roles: any[] = [];

  constructor(private http: HttpClient) { }

  public get user(): User {
    return this._user;
  }

  public set user(val: User) {
    this._user = val;
  }

  public get roles(): any[] {
    return this._roles;
  }

  public set roles(val: any[]) {
    this._roles = val;
  }

  public setUserRoles(userRoles: any): void {
    this.roles = userRoles || [];
    if (this._user) {
      this._user.roles = this.roles;
    }
  }

  public formatUser(user_details): void {
    const usr = new User();
    usr.brand = user_details.brand;
    usr.first_name = user_details.profile?.names?.first_name;
    usr.last_name = user_details.profile?.names?.last_system_name;
    usr.default_locale = user_details.preferences?.default_locale;
    usr.default_unit_system = user_details.preferences?.default_unit_system;
    usr.default_time_zone = user_details.preferences?.default_time_zone;
    usr.username = user_details.username;
    usr.user_id = user_details.user_id;
    usr.resources = user_details.resources || [];
    usr.roles = this.roles;

    this.user = usr;
  }
}

